import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Relatório de Bens Patrimoniais',
  path: '/patrimonio/relatoriobem',
  name: 'patrimonio-relatorio-bem',
  component: () => import('@/views/patrimonio/relatoriobem/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.RELATORIOPATRIMONIONOVO_MENU_1200400199],
  },
  goesToMenu: true,
 },
]
